import { ApiRoutes } from "../common/apiRoutes";
import Http from "../services/http";

// Get list of chefs :
export const getChefsList = (page: number | null, limit: number | string, filter: number, search: string, sortField: any, sortDirection: any) => {
  return Http.get(`${ApiRoutes.chef}?page=${page}&limit=${limit}&verify_status=${filter}&search=${search}&sort_field=${sortField}&sort=${sortDirection}`);
};

// Get chef detail by Id :
export const getChefDetailByIds = (id: any) => {
  return Http.get(`${ApiRoutes.chef}/${id}`);
};

// Add chef :
export const addPersonalDetailsChefAPI = (data: any) => {
  return Http.post(ApiRoutes.chefPersonalDetails, data);
};

export const addProfessionalDetailsChefAPI = (data: any) => {
  return Http.post(ApiRoutes.chefProfessionalDetails, data);
};

export const addAddressDetailsChefAPI = (data: any) => {
  return Http.post(ApiRoutes.chefAddressDetails, data);
};

export const addRatesDetailsChefAPI = (data: any) => {
  return Http.post(ApiRoutes.chefRatesDetails, data);
};

export const addAreaDetailsChefAPI = (data: any) => {
  return Http.post(ApiRoutes.chefAreaDetails, data);
};

export const addGeneralAvailabilityChefAPI = (data: any) => {
  return Http.post(ApiRoutes.chefGeneralAvailability, data);
};

export const deleteChefAPI = (id: any) => {
  return Http.delete(`${ApiRoutes.deletChef}/${id}`);
};

export const editChefAPI = (id: any, data: any) => {
  return Http.put(`chef/${id}`, data);
};
export const getChefStatusAPI = (data: any) => {
  return Http.put(ApiRoutes.getChefStatus, data);
};
export const getChefVerifiedAPI = (data: any) => {
  return Http.put(ApiRoutes.getChefVerified, data);
};
export const addChefImageAPI = (data: any) => {
  return Http.put(ApiRoutes.addChefImage, data);
};
export const areaDetailsAPI = (data: any) => {
  return Http.post(ApiRoutes.addChefAreaDetails, data);
};
export const addressDetailsAPI = (data: any) => {
  return Http.post(ApiRoutes.addChefAddressDetails, data);
};
export const addratesDetailsAPI = (data: any) => {
  return Http.post(ApiRoutes.addChefRatesDetails, data);
};
export const getChefRatesAPI = () => {
  return Http.get(ApiRoutes.getChefRates);
};
export const getCuisineListAPI = () => {
  return Http.get(ApiRoutes.getCuisineList);
};
export const getDishesListAPI = (id:any) => {
  return Http.get(`dish/list/${id}`);
};
export const editChefMenuAPI = (id: any, data: any) => {
  return Http.post(`chef/menu/${id}`, data);
};
export const getChefMenuAPI = (id: any) => {
  return Http.get(`chef/menu/${id}`);
};
export const getChefListAPI = (long:any,lat:any) => {
  return Http.get(`chef/list?long=${long}&lat=${lat}`);
};
export const addBookingAPI = (data: any) => {
  return Http.post("booking", data);
};
// export const addVacationAPI = (id: any, data: any) => {
//   return Http.put(`chef/${id}`, data);
// };

export const addVacationAPI = (id: any, data: any) => {
  return Http.post(`chef/vacation/${id}`, data);
};

export const deleteVacationAPI = (id: any, removeId: any) => {
  return Http.delete(`chef/vacation/${id}/${removeId}`);
};

export const getSlotsAPI = (id: any, data: any) => {
  return Http.post(`chef/slot/${id}`, data);
};

export const getRateSummaryAPI = (data:any) => {
  return Http.post('booking/get-rate-summary',data);
};
export const stripeConnectAPI = (data:any) => {
  return Http.post('chef/stripe-details',data);
};